<app-page-header
  title="Home"
  active_item="Informações"
  titleLink="/reports"
></app-page-header>
<h5>{{ "common.accountInfo" | translate }}</h5>
<div class="row" id="user-profile">
  <div class="col-lg-12">
    <div class="card rounded-10 shadow">
      <div class="card-body">
        <div class="row">
          <div class="col">
            <div class="user-wrap">
              <div class="table-responsive">
                <table class="table row table-borderless bg-transparent">
                  <tbody class="col">
                    <tr>
                      <td>
                        <p class="fs-17">
                          <strong
                            >{{ "common.accountId" | translate }}:
                          </strong>
                          {{ account.id }}
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="border-top">
          <div class="wideget-user-tab">
            <div class="tab-menu-heading">
              <div class="tabs-menu1">
                <ul ngbNav #nav="ngbNav" [activeId]="selected">
                  <li [ngbNavItem]="1" *ngIf="this.account.personType == 0">
                    <a ngbNavLink>{{ "common.company" | translate }}</a>
                    <ng-template ngbNavContent>
                      <div class="card">
                        <div class="card-body">
                          <div class="tab-pane active show" id="tab-51">
                            <div id="profile-log-switch-1">
                              <div class="media-heading">
                                <td>
                                  <p class="fs-17 text-uppercase">
                                    <strong>{{
                                      "common.company" | translate
                                    }}</strong>
                                  </p>
                                </td>
                              </div>
                              <div class="table-responsive">
                                <table
                                  class="table row table-borderless bg-transparent"
                                >
                                  <tbody class="col-lg-12 col-xl-6 p-0">
                                    <tr>
                                      <td>
                                        <span
                                          ><strong
                                            >{{ "common.cnpj" | translate }}:
                                          </strong>
                                          {{
                                            account.company.cnpj
                                              | mask: "CPF_CNPJ"
                                          }}</span
                                        >
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <span
                                          ><strong
                                            >{{
                                              "common.legalName" | translate
                                            }}:
                                          </strong>
                                          {{
                                            account.company.razaoSocial
                                          }}</span
                                        >
                                      </td>
                                    </tr>
                                  </tbody>
                                  <tbody class="col-lg-12 col-xl-6 p-0">
                                    <tr>
                                      <td>
                                        <span
                                          ><strong
                                            >{{ "common.email" | translate }}:
                                          </strong>
                                          {{ account.company.email }}</span
                                        >
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <span
                                          ><strong
                                            >{{ "common.phone" | translate }}:
                                          </strong>
                                          {{
                                            account.company.phone
                                              | mask: "(00) 00000-0000"
                                          }}</span
                                        >
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </li>
                  <li [ngbNavItem]="2">
                    <a ngbNavLink>{{ "common.address" | translate }}</a>
                    <ng-template ngbNavContent>
                      <div class="card">
                        <div class="card-body">
                          <div class="tab-pane active show" id="tab-52">
                            <div id="profile-log-switch-2">
                              <div class="media-heading">
                                <td>
                                  <p class="fs-17 text-uppercase">
                                    <strong>{{
                                      "common.address" | translate
                                    }}</strong>
                                  </p>
                                </td>
                              </div>
                              <div class="table-responsive">
                                <table
                                  class="table row table-borderless bg-transparent"
                                >
                                  <tbody class="col-lg-12 col-xl-6 p-0">
                                    <tr>
                                      <td>
                                        <span
                                          ><strong
                                            >{{
                                              "common.streetName" | translate
                                            }}
                                            :</strong
                                          >
                                          {{ account.adress.logradouro }}</span
                                        >
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <span
                                          ><strong
                                            >{{
                                              "common.neighborhood" | translate
                                            }}
                                            :</strong
                                          >
                                          {{ account.adress.bairro }}</span
                                        >
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <span
                                          ><strong
                                            >{{
                                              "common.city" | translate
                                            }}
                                            :</strong
                                          >
                                          {{ account.adress.cidade }}</span
                                        >
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <span
                                          ><strong
                                            >{{
                                              "common.additionalInfo"
                                                | translate
                                            }}
                                            :</strong
                                          >
                                          {{ account.adress.complemento }}</span
                                        >
                                      </td>
                                    </tr>
                                  </tbody>
                                  <tbody class="col-lg-12 col-xl-6 p-0">
                                    <tr>
                                      <td>
                                        <span
                                          ><strong
                                            >{{
                                              "common.number" | translate
                                            }}
                                            :</strong
                                          >
                                          {{ account.adress.numero }}</span
                                        >
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <span
                                          ><strong
                                            >{{
                                              "common.postalCode" | translate
                                            }}
                                            :</strong
                                          >
                                          {{
                                            account.adress.cep
                                              | mask: "00000-000"
                                          }}</span
                                        >
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <span
                                          ><strong
                                            >{{
                                              "common.state" | translate
                                            }}
                                            :</strong
                                          >
                                          {{ account.adress.estado }}</span
                                        >
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </li>
                  <li [ngbNavItem]="3">
                    <a ngbNavLink>{{
                      "common.responsibleParty" | translate
                    }}</a>
                    <ng-template ngbNavContent>
                      <div class="card">
                        <div class="card-body">
                          <div class="tab-pane" id="tab-61">
                            <div id="profile-log-switch-3">
                              <div class="media-heading">
                                <td>
                                  <p class="fs-17 text-uppercase">
                                    <strong>{{
                                      "common.responsibleParty" | translate
                                    }}</strong>
                                  </p>
                                </td>
                              </div>
                              <div class="table-responsive">
                                <table
                                  class="table row table-borderless bg-transparent"
                                >
                                  <tbody class="col-lg-12 col-xl-6 p-0">
                                    <tr>
                                      <td>
                                        <span
                                          ><strong
                                            >{{
                                              "common.ssn" | translate
                                            }}
                                            :</strong
                                          >
                                          {{
                                            account.sponsor.cpf
                                              | mask: "CPF_CNPJ"
                                          }}</span
                                        >
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <span
                                          ><strong
                                            >{{
                                              "common.email" | translate
                                            }}
                                            :</strong
                                          >
                                          {{ account.sponsor.email }}</span
                                        >
                                      </td>
                                    </tr>
                                  </tbody>
                                  <tbody class="col-lg-12 col-xl-6 p-0">
                                    <tr>
                                      <td>
                                        <span
                                          ><strong
                                            >{{
                                              "common.name" | translate
                                            }}
                                            :</strong
                                          >
                                          {{ account.sponsor.name }}</span
                                        >
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <span
                                          ><strong
                                            >{{
                                              "common.phone" | translate
                                            }}
                                            :</strong
                                          >
                                          {{
                                            account.sponsor.phone
                                              | mask: "(00) 00000-0000"
                                          }}</span
                                        >
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </li>
                  <li [ngbNavItem]="4">
                    <a ngbNavLink>{{ "common.bankDetails" | translate }}</a>

                    <ng-template ngbNavContent>
                      <div class="card">
                        <div class="card-body">
                          <div class="media-heading">
                            <td>
                              <p class="fs-17 text-uppercase">
                                <strong>{{
                                  "common.bankDetails" | translate
                                }}</strong>
                              </p>
                            </td>
                          </div>
                          <div class="table-responsive">
                            <table
                              class="table row table-borderless bg-transparent"
                            >
                              <tbody class="col-lg-12 col-xl-6 p-0">
                                <tr>
                                  <td>
                                    <span
                                      ><strong
                                        >{{
                                          "common.bankName" | translate
                                        }}:</strong
                                      >
                                      {{
                                        account?.bankDetails?.bankName || " "
                                      }}
                                    </span>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <span
                                      ><strong
                                        >{{
                                          "common.bankCode" | translate
                                        }}:</strong
                                      >
                                      {{
                                        account?.bankDetails?.bankCode || " "
                                      }}
                                    </span>
                                  </td>
                                </tr>
                              </tbody>

                              <tbody class="col-lg-12 col-xl-6 p-0">
                                <tr>
                                  <td>
                                    <span
                                      ><strong
                                        >{{
                                          "common.agency" | translate
                                        }}:</strong
                                      >
                                      {{ account?.bankDetails?.agency || " " }}
                                    </span>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <span
                                      ><strong
                                        >{{
                                          "common.account" | translate
                                        }}:</strong
                                      >
                                      {{ account?.bankDetails?.account || " " }}
                                    </span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </li>
                  <li [ngbNavItem]="5">
                    <a ngbNavLink>{{ "common.api" | translate }}</a>
                    <ng-template ngbNavContent>
                      <div class="card">
                        <div class="card-body">
                          <div class="tab-pane" id="tab-62">
                            <app-mtls-certificate
                              [account]="account"
                            ></app-mtls-certificate>
                            <hr class="my-4" />
                            <div id="profile-log-switch-4">
                              <div class="d-flex align-items-center justify-content-between mb-3">
                                <p class="fs-17 mb-0">
                                  <strong>{{
                                    "common.apiAccessTokens" | translate
                                  }}</strong>
                                </p>
                                <button
                                  type="button"
                                  class="btn btn-pill btn-primary btn-sm d-inline-flex align-items-center"
                                  [disabled]="rotatingApiToken"
                                  (click)="rotateApiToken()"
                                >
                                  <mat-icon
                                    *ngIf="!rotatingApiToken"
                                    class="me-1"
                                    style="font-size: 18px; width: 18px; height: 18px"
                                  >sync</mat-icon>
                                  <span *ngIf="rotatingApiToken" class="spinner-border spinner-border-sm me-1" role="status"></span>
                                  Rotacionar credenciais
                                </button>
                              </div>
                              <div class="table-responsive">
                                <div class="table row g-2">
                                  <div class="col-lg-4 col-xl px-3">
                                    <div class="mb-4">
                                      <div class="p-0 mb-1 fw-bold">
                                        {{ "common.clientId" | translate }}
                                      </div>
                                      <div
                                        class="d-inline-block bg-tertiary px-3 py-2 rounded-3 fs-7"
                                      >
                                        <i
                                          (click)="copyId(account.clientId)"
                                          class="fe fe-copy mx-2 copy-icon"
                                        ></i>
                                        {{ account.clientId }}
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-lg-4 col-xl px-3">
                                    <div class="mb-4">
                                      <div class="p-0 mb-1 fw-bold">
                                        {{ "common.secret" | translate }}
                                      </div>
                                      <div
                                        class="d-inline-block bg-tertiary px-3 py-2 rounded-3 fs-7"
                                      >
                                        <i
                                          (click)="copyId(account.secret)"
                                          class="fe fe-copy mx-2 copy-icon"
                                        ></i>
                                        {{ account.secret }}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <hr class="my-4" />
                            <div id="profile-log-switch-4">
                              <div class="d-flex align-items-center justify-content-between mb-3">
                                <p class="fs-17 mb-0">
                                  <strong>{{
                                    "common.gameApiToken" | translate
                                  }}</strong>
                                </p>
                                <button
                                  type="button"
                                  class="btn btn-pill btn-primary btn-sm d-inline-flex align-items-center"
                                  [disabled]="rotatingGameToken"
                                  (click)="rotateGameToken()"
                                >
                                  <mat-icon
                                    *ngIf="!rotatingGameToken"
                                    class="me-1"
                                    style="font-size: 18px; width: 18px; height: 18px"
                                  >sync</mat-icon>
                                  <span *ngIf="rotatingGameToken" class="spinner-border spinner-border-sm me-1" role="status"></span>
                                  Rotacionar credenciais
                                </button>
                              </div>
                              <div class="table-responsive">
                                <div class="table row g-2">
                                  <div class="col-lg-4 col-xl px-3">
                                    <div class="mb-4">
                                      <div class="p-0 mb-1 fw-bold">
                                        {{ "common.webhookToken" | translate }}
                                      </div>
                                      <div
                                        class="d-inline-block bg-tertiary px-3 py-2 rounded-3 fs-7"
                                      >
                                        <i
                                          (click)="copyId(account.clientId)"
                                          class="fe fe-copy mx-2 copy-icon"
                                        ></i>
                                        {{ account.tokenGameRegistration }}
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col-lg-4 col-xl px-3">
                                    <div class="mb-4">
                                      <div class="p-0 mb-1 fw-bold">
                                        {{ "common.webhookUrl" | translate }}
                                      </div>
                                      <div
                                        class="d-inline-block bg-tertiary px-3 py-2 rounded-3 fs-7"
                                      >
                                        <i
                                          (click)="copyId(account.secret)"
                                          class="fe fe-copy mx-2 copy-icon"
                                        ></i>
                                        {{ account.webhookApiGame }}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </li>
                  <!-- <li [ngbNavItem]="6">
                    <a ngbNavLink>{{ "common.fees" | translate }}</a>
                    <ng-template ngbNavContent>
                      <div class="card">
                        <div class="card-body">
                          <div class="tab-pane" id="tab-72">
                            <div id="profile-log-switch-5">
                              <div class="media-heading">
                                <td>
                                  <p class="fs-17 text-uppercase">
                                    <strong>{{
                                      "common.feeSettings" | translate
                                    }}</strong>
                                  </p>
                                </td>
                              </div>
                              <div class="table row g-3">
                                <div class="col-lg-4 col-xl px-3">
                                  <div class="mb-4 fw-bold fs-17">
                                    {{ "common.deposit" | translate }}
                                  </div>
                                  <div class="mb-4">
                                    <div class="p-0 mb-1 fw-bold">
                                      {{ "common.app" | translate }}
                                    </div>
                                    <div
                                      class="d-inline-block bg-light px-3 py-2 rounded-3 fs-7"
                                    >
                                      {{
                                        accountTaxes.applicationDepositTaxPercent
                                          | mask
                                            : "separator.2"
                                            : {
                                                decimalMarker: ",",
                                                leadZero: true,
                                              }
                                      }}% + R$
                                      {{
                                        accountTaxes.applicationDepositTaxValue
                                          | mask
                                            : "separator.3"
                                            : {
                                                decimalMarker: ",",
                                                leadZero: true,
                                              }
                                      }}
                                    </div>
                                  </div>
                                  <div class="mb-4">
                                    <div class="p-0 mb-1 fw-bold">
                                      {{ "common.api" | translate }}
                                    </div>
                                    <div
                                      class="d-inline-block bg-light px-3 py-2 rounded-3 fs-7"
                                    >
                                      {{
                                        accountTaxes.apiDepositTaxPercent
                                          | mask
                                            : "separator.2"
                                            : {
                                                decimalMarker: ",",
                                                leadZero: true,
                                              }
                                      }}% + R$
                                      {{
                                        accountTaxes.apiDepositTaxValue
                                          | mask
                                            : "separator.3"
                                            : {
                                                decimalMarker: ",",
                                                leadZero: true,
                                              }
                                      }}
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-4 col-xl px-3">
                                  <div class="mb-4 fw-bold fs-17">
                                    {{ "common.withdraw" | translate }}
                                  </div>
                                  <div class="mb-4">
                                    <div class="p-0 mb-1 fw-bold">
                                      {{ "common.app" | translate }}
                                    </div>
                                    <div
                                      class="d-inline-block bg-light px-3 py-2 rounded-3 fs-7"
                                    >
                                      {{
                                        accountTaxes.applicationWithDrawTaxPercent
                                          | mask
                                            : "separator.2"
                                            : {
                                                decimalMarker: ",",
                                                leadZero: true,
                                              }
                                      }}% + R$
                                      {{
                                        accountTaxes.applicationWithDrawTaxValue
                                          | mask
                                            : "separator.3"
                                            : {
                                                decimalMarker: ",",
                                                leadZero: true,
                                              }
                                      }}
                                    </div>
                                  </div>
                                  <div class="mb-4">
                                    <div class="p-0 mb-1 fw-bold">
                                      {{ "common.api" | translate }}
                                    </div>
                                    <div
                                      class="d-inline-block bg-light px-3 py-2 rounded-3 fs-7"
                                    >
                                      {{
                                        accountTaxes.apiWithDrawTaxPercent
                                          | mask
                                            : "separator.2"
                                            : {
                                                decimalMarker: ",",
                                                leadZero: true,
                                              }
                                      }}% + R$
                                      {{
                                        accountTaxes.apiWithDrawTaxValue
                                          | mask
                                            : "separator.3"
                                            : {
                                                decimalMarker: ",",
                                                leadZero: true,
                                              }
                                      }}
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-4 col-xl px-3">
                                  <div class="mb-4 fw-bold fs-17">
                                    {{ "common.cryptoassets" | translate }}
                                  </div>
                                  <div class="mb-4">
                                    <div class="p-0 mb-1 fw-bold">
                                      {{ "common.app" | translate }}
                                    </div>
                                    <div
                                      class="d-inline-block bg-light px-3 py-2 rounded-3 fs-7"
                                    >
                                      {{
                                        accountTaxes.applicationCriptoTaxPercent
                                          | mask
                                            : "separator.2"
                                            : {
                                                decimalMarker: ",",
                                                leadZero: true,
                                              }
                                      }}% + R$
                                      {{
                                        accountTaxes.applicationCriptoTaxValue
                                          | mask
                                            : "separator.3"
                                            : {
                                                decimalMarker: ",",
                                                leadZero: true,
                                              }
                                      }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </li> -->
                  <li [ngbNavItem]="7">
                    <a ngbNavLink>{{ "common.configurations" | translate }}</a>
                    <ng-template ngbNavContent>
                      <div class="card">
                        <div class="card-body">
                          <div class="tab-pane active show" id="tab-51">
                            <div id="profile-log-switch-1">
                              <div class="media-heading">
                                <p class="fs-17 text-uppercase">
                                  <strong>{{
                                    "common.configurations" | translate
                                  }}</strong>
                                  <button
                                    type="button"
                                    class=""
                                    (click)="openEditConfigModal()"
                                    title="Editar configurações"
                                  >
                                    <i class="fe fe-edit"></i>
                                  </button>
                                </p>
                              </div>
                              <div class="table row g-3">
                                <div class="px-3 col-lg-4 col-xl">
                                  <div class="mb-4">
                                    <div class="p-0 mb-1 fw-bold">
                                      {{ "common.depositLimits" | translate }}
                                      ({{
                                        "common.perTransaction" | translate
                                      }}):
                                    </div>
                                    <div
                                      class="d-inline-block bg-light px-3 py-2 rounded-3 fs-7"
                                    >
                                      {{
                                        account.depositConfiguration
                                          .valueMinRequest | formatCurrency
                                      }}
                                      –
                                      {{
                                        account.depositConfiguration
                                          .valueMaxRequest | formatCurrency
                                      }}
                                    </div>
                                  </div>

                                  <div class="mb-4">
                                    <div class="p-0 mb-1 fw-bold">
                                      {{ "common.withdrawLimits" | translate }}
                                      ({{
                                        "common.perTransaction" | translate
                                      }}):
                                    </div>
                                    <div
                                      class="d-inline-block bg-light px-3 py-2 rounded-3 fs-7"
                                    >
                                      {{
                                        account.withDrawConfiguration
                                          .valueMinRequest | formatCurrency
                                      }}
                                      –
                                      {{
                                        account.withDrawConfiguration
                                          .valueMaxRequest | formatCurrency
                                      }}
                                    </div>
                                  </div>
                                  <div class="mb-4">
                                    <div class="p-0 mb-1 fw-bold">
                                      {{
                                        "common.block3rdPartyDeposit"
                                          | translate
                                      }}:
                                    </div>
                                    <div
                                      class="d-inline-block bg-light px-3 py-2 rounded-3 fs-7"
                                    >
                                      {{
                                        account?.featureFlagRefundPix === true
                                          ? ("common.yes" | translate)
                                          : ("common.no" | translate)
                                      }}
                                    </div>
                                  </div>
                                  <div class="mb-4">
                                    <div class="p-0 mb-1 fw-bold">
                                      {{
                                        "common.featureFlagCpfWithdraw"
                                          | translate
                                      }}:
                                    </div>
                                    <div
                                      class="d-inline-block bg-light px-3 py-2 rounded-3 fs-7"
                                    >
                                      {{
                                        account?.featureFlagCpfWithdraw === true
                                          ? ("common.yes" | translate)
                                          : ("common.no" | translate)
                                      }}
                                    </div>
                                  </div>
                                </div>
                                <div class="col-lg-4 col-xl p-0">
                                  <div class="mb-4">
                                    <div class="p-0 mb-1 fw-bold">
                                      {{
                                        "common.automaticWithdrawLimit"
                                          | translate
                                      }}:
                                    </div>
                                    <div
                                      class="d-inline-block bg-light px-3 py-2 rounded-3 fs-7"
                                    >
                                      {{
                                        account.withDrawConfiguration
                                          .valorMinimoSaqueAutomatico
                                          | formatCurrency
                                      }}
                                    </div>
                                  </div>

                                  <div class="mb-4">
                                    <div class="p-0 mb-1 fw-bold">
                                      {{
                                        "common.24hWithdrawLimit" | translate
                                      }}:
                                    </div>
                                    <div
                                      class="d-inline-block bg-light px-3 py-2 rounded-3 fs-7"
                                    >
                                      {{
                                        account.withDrawConfiguration
                                          .valueExpired | formatCurrency
                                      }}
                                    </div>
                                  </div>

                                  <div class="mb-4">
                                    <div class="p-0 mb-1 fw-bold">
                                      {{ "common.24hWithdrawQt" | translate }}:
                                    </div>
                                    <div
                                      class="d-inline-block bg-light px-3 py-2 rounded-3 fs-7"
                                    >
                                      {{
                                        account.withDrawConfiguration
                                          .amountExpired
                                      }}
                                    </div>
                                  </div>

                                  <div class="mb-4">
                                    <div class="p-0 mb-1 fw-bold">
                                      {{
                                        "common.withdrawAutomaticCancel"
                                          | translate
                                      }}:
                                    </div>
                                    <div
                                      class="d-inline-block bg-light px-3 py-2 rounded-3 fs-7"
                                    >
                                      {{
                                        account?.withDrawConfiguration
                                          ?.analyzeWithdrawal === true
                                          ? ("common.yes" | translate)
                                          : ("common.no" | translate)
                                      }}
                                    </div>
                                  </div>
                                </div>

                                <div class="col-lg-4 col-xl p-0">
                                  <div class="mb-4">
                                    <div class="p-0 fw-bold mb-1">
                                      {{
                                        "common.activeIpValidation" | translate
                                      }}:
                                    </div>
                                    <div class="p-0 d-flex flex-wrap">
                                      <div
                                        class="d-inline-block bg-light px-3 py-2 rounded-3 fs-7"
                                      >
                                        {{
                                          account?.validateIp === true
                                            ? ("common.yes" | translate)
                                            : ("common.no" | translate)
                                        }}
                                      </div>
                                    </div>
                                  </div>

                                  <div class="mb-4">
                                    <div class="p-0 fw-bold m-0">
                                      {{
                                        "common.authorizedIpList" | translate
                                      }}:
                                    </div>
                                    <ng-container
                                      *ngIf="
                                        account?.listsIp?.length;
                                        else noIPs
                                      "
                                    >
                                      <div
                                        class="d-flex flex-wrap px-0 py-1 gap-2"
                                      >
                                        <div
                                          *ngFor="let ip of account.listsIp"
                                          class="bg-light px-3 py-2 rounded-3 fs-7"
                                        >
                                          {{ ip }}
                                        </div>
                                      </div>
                                    </ng-container>
                                    <ng-template #noIPs>
                                      <div
                                        class="d-inline-block bg-light px-3 py-2 rounded-3 fs-7"
                                      >
                                        {{ "common.none" | translate }}
                                      </div>
                                    </ng-template>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div [ngbNavOutlet]="nav"></div>
    </div>
  </div>
  <ng-template #requestTOTPCode let-modal>
    <div class="modal-header">
      <h5 class="modal-title">{{ "common.informAuthToken" | translate }}</h5>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="modal.dismiss('Cross click'); isLoaded = true"
      ></button>
    </div>
    <div class="modal-body">
      <div class="form-group mt-2">
        <p *ngIf="errorMessage.length > 0" class="text-danger">
          {{ errorMessage }}
        </p>
      </div>
      <div class="form-group mb-3">
        <input
          type="text"
          class="form-control"
          id="authToken"
          placeholder="Token"
          [(ngModel)]="validationCode"
          (keyup.enter)="validateTotp()"
        />
      </div>
    </div>
    <div class="modal-footer text-center">
      <button
        type="submit"
        class="btn btn-lg btn-primary btn-pill mx-auto d-block"
        (click)="validateTotp()"
      >
        {{ "common.validateButton" | translate }}
      </button>
    </div>
  </ng-template>
</div>
